import React from 'react';
import MarketPreviews from 'app/shared/components/MarketPreviews';
import { gaEvents } from 'app/shared/constants/AnalyticsConstants';

import type { Market } from 'app/shared/types/Market';

interface TopMarketsProps {
    markets: Array<Market>;
    isSmallScreen: boolean;
    isMobile: boolean;
}

const TopMarkets: React.FunctionComponent<TopMarketsProps> = (props) => {
    const { markets, isSmallScreen, isMobile } = props;

    return (
        <MarketPreviews
            markets={markets}
            heading="Top Rental Markets"
            subject="top markets"
            copyText="Based on current median rent"
            useFilters
            isSmallScreen={isSmallScreen}
            isMobile={isMobile}
            gaEvent={gaEvents.VIEW_TOP_MARKET}
        />
    );
};

export default TopMarkets;
